module.exports = __webpack_public_path__ + "static/media/independenceday.94ccc0e4.jpeg";